import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Typography } from '@material-ui/core';
import CollapseListItem from './CollapseListItem'
import GreenCheckbox from './GreenCheckbox';

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(0),
    fontSize: '16',
  },
  programItem: {
    padding: '0.5em 0.5em 0.5em 3em',
    fontSize: 14,
  },
  listItemText: {
    fontSize:'11pt',
    textAlign: "center",
  },
}));
  
export default function CheckItem(props) {
  const classes = useStyles();

  function makeTypoList(programs){
    const list = [];

    for(let i = 0; i < programs.length; i++) {
      list.push(
        <Typography 
          key={programs[i]} 
          className={classes.programItem} 
        >
          â€¢ {programs[i]}
        </Typography>
      );
    }

    return list;
  }

  return (
    <CollapseListItem 
      mainItem={[
        <GreenCheckbox/>,
        <div 
          key={"ListContent" + props.number} 
          style={{
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "center", 
            flexGrow: 2 , 
            padding : '0.5em 0em 0em 0em'
          }}
        >
          <Typography className={classes.typography}>
            {"Article " + props.number + ":"}
          </Typography>
          <Typography className={classes.typography}>
            {props.link}
          </Typography>
        </div>
      ]}
      collapseItem={[
        <Divider key={"divider1" + props.number} light= {true}/>,
        makeTypoList(props.programs),
        <Divider key={"divider2" + props.number} light={true}/>
      ]}
    />
  );
}

